import React, { useMemo } from 'react';
import { ItemDelegate } from '@leverege/molten/imagine';
import { ItemInfoScreen } from '@leverege/molten/screens';
export default function ItemScreenWrapper(props) {
  const {
    match,
    layout,
    location,
    history,
    parentItem,
    relationship,
    title,
    icon,
    ...rest
  } = props;
  const {
    search
  } = location;
  const {
    push
  } = history;
  const {
    type
  } = parentItem;
  if (!search) {
    push(`?v=t-${type}%3A${layout}`);
  }
  const itemInfoScreenProps = useMemo(() => {
    const iRel = relationship.createItem(match);
    const delegate = new ItemDelegate({
      match,
      relationship: iRel,
      id: iRel.id
    });
    const itemInfoScreenProps = {
      match,
      ...rest,
      parentItem,
      relationship: iRel,
      resourceId: iRel.id,
      objectType: type,
      delegate,
      actions: delegate,
      title,
      icon
    };
    return itemInfoScreenProps;
  }, [type, match, rest]);
  return /*#__PURE__*/React.createElement(ItemInfoScreen, itemInfoScreenProps);
}